window.addEventListener("load", function () {

    const loader = document.getElementById("intro-loader");

    if (!loader) return;

    // Skip if already played this session
    if (sessionStorage.getItem("introPlayed")) {
        loader.remove();
        return;
    }

    sessionStorage.setItem("introPlayed", "true");

    setTimeout(function () {

        loader.classList.add("hide");

        setTimeout(function () {
            loader.remove();
        }, 600);

    }, 1800);

});